module.exports = __webpack_public_path__ + "static/img/4.4c119b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/4.png
// module id = rLOI
// module chunks = 0